import type { EmitMetric, ReportType } from '../models/report-models';

export function countReportData(
  reportType: ReportType,
  reportDataType: string,
  reportDataCount: number,
  emitMetric: EmitMetric,
) {
  if (reportDataCount < 10) {
    emitMetric(`${reportType} ${reportDataType} ${reportDataCount}`);
  } else if (reportDataCount >= 10) {
    // Group data points with a count of 10 or more together to prevent metric bloat
    emitMetric(`${reportType} ${reportDataType} 10OrMore`);
  } else {
    emitMetric(`${reportType} ${reportDataType} undefined`);
  }
}
